<template>
  <div>
    <ValidationObserver ref="observer">
      <ValidationProvider name="รูปโปรไฟล์" v-slot="{ errors }">
        <UploadDocument v-model="input.profileImage">
          <template v-slot="props">
            <custom-input
              :loading="props.loading"
              :value="props.filename"
              prepend-icon="mdi-attachment"
              readonly
              :error-messages="errors"
            ></custom-input>
          </template>
        </UploadDocument>
      </ValidationProvider>

      <ValidationProvider
        :rules="{
          required: true,
        }"
        name="ชื่อ"
        v-slot="{ errors }"
      >
        <div class="primary--text">
          ชื่อ - นามสกุล <span class="red--text"> *</span>
        </div>
        <custom-input
          v-model="input.name"
          :error-messages="errors"
          placeholder="ชื่อ - นามสกุล"
        ></custom-input>
        <div v-if="errors" class="error--text" style="font-size: 12px;">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <ValidationProvider
        :rules="{
          required: true,
        }"
        name="เพศ"
        v-slot="{ errors }"
      >
        <div class="primary--text pt-3">
          เพศ<span class="red--text"> *</span>
        </div>
        <v-radio-group
          color="primary"
          :error-messages="errors"
          v-model="input.gender"
          row
        >
          <v-radio label="ชาย" value="ชาย"></v-radio>
          <v-radio label="หญิง" value="หญิง"></v-radio>
          <v-radio label="ไม่ระบุ" value="ไม่ระบุ"></v-radio>
        </v-radio-group>
      </ValidationProvider>
      <!-- <ValidationProvider
        :rules="{
          required: true,
        }"
        name="อายุ"
        v-slot="{ errors }"
      >
        <div class="primary--text">อายุ<span class="red--text"> *</span></div>
        <custom-input
          v-model="input.age"
          :error-messages="errors"
          placeholder="อายุ"
        ></custom-input>
      </ValidationProvider> -->
      <ValidationProvider
        :rules="{
          required: true,
        }"
        name="วัน-เดือน-ปี เกิด"
        v-slot="{ errors }"
      >
        <div class="primary--text">
          วัน-เดือน-ปี เกิด <span class="red--text"> *</span>
        </div>

        <div v-if="type !== 'edit'">
          <BirthdayPicker v-model="input.dob">
            <custom-input
              :value="
                input.dob
                  ? moment(input.dob)
                      .add(543, 'year')
                      .format('DD/MM/YYYY')
                  : ''
              "
              placeholder="DD/MM/YYYY"
              readonly
              appendOuterIcon="mdi-calendar"
              :error-messages="errors"
            ></custom-input>
          </BirthdayPicker>
        </div>
        <div v-else class="py-3">
          {{
            moment(input.dob)
              .add(543, "year")
              .format("DD/MM/YYYY")
          }}
          <custom-input
            :value="
              input.dob
                ? moment(input.dob)
                    .add(543, 'year')
                    .format('DD/MM/YYYY')
                : ''
            "
            :error-messages="errors"
            placeholder="DD/MM/YYYY"
            :disabled="true"
            type="hidden"
          ></custom-input>
          <div class="red--text pt-1" style="font-size: 11px;">
            หมายเหตุ : ไม่อนุญาตให้เปลี่ยนแปลงข้อมูล วัน เดือน ปี เกิดด้วยตัวเอง
            หากต้องการเปลี่ยนแปลง สามารถแจ้งเรื่องผ่านทาง email ที่
            <a href="mailto:customerservice.lamy.co.th" class="red--text"
              >customerservice.lamy.co.th</a
            >
          </div>
        </div>
        <div v-if="errors" class="error--text" style="font-size: 12px;">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <ValidationProvider
        :rules="{
          required: true,
          thai_phonenumber: true,
          digits: 10,
          regex: /^[0][3-9][0-9]{4}[0-9]{4}$/,
        }"
        name="เบอร์โทรศัพท์"
        v-slot="{ errors }"
      >
        <div class="primary--text pt-3">
          เบอร์โทร <span class="red--text"> *</span>
        </div>

        <custom-input
          type="number"
          v-model="input.phoneNumber"
          maxlength="10"
          placeholder="กรอกตัวเลข 10 หลัก"
          numberOnly
          :error-messages="errors"
        ></custom-input>
        <div v-if="errors" class="error--text" style="font-size: 12px;">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <ValidationProvider
        :rules="'required|email'"
        name="อีเมล"
        v-slot="{ errors }"
      >
        <div class="primary--text pt-3">
          อีเมล <span class="red--text"> *</span>
        </div>

        <custom-input
          v-model.trim="input.email"
          :error-messages="errors"
          placeholder="อีเมล"
        ></custom-input>
        <div v-if="errors" class="error--text" style="font-size: 12px;">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <ValidationProvider :rules="'required'" name="อาชีพ" v-slot="{ errors }">
        <div class="primary--text pt-3">
          อาชีพ <span class="red--text"> *</span>
        </div>

        <v-select
          v-model="input.job"
          :items="jobOptions"
          placeholder="อาชีพ"
          hide-details
        ></v-select>
        <div v-if="errors" class="error--text" style="font-size: 12px;">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <template v-if="input.job && input.job === 'อื่นๆ (โปรดระบุ)'">
        <ValidationProvider
          :rules="'required'"
          name="อาชีพ"
          v-slot="{ errors }"
        >
          <custom-input
            v-model.trim="input.other_job"
            :error-messages="errors"
            placeholder="โปรดระบุอาชีพ"
          ></custom-input>

          <div v-if="errors" class="error--text" style="font-size: 12px;">
            {{ errors[0] }}
          </div>
        </ValidationProvider>
      </template>
    </ValidationObserver>

    <!-- Button -->
    <v-row class="pt-6">
      <v-col cols="12">
        <v-btn
          :loading="saveloading"
          @click="submitForm"
          tile
          dark
          color="#000"
          style="width: 100%; height: 48px;"
        >
          {{ type == "create" ? "ลงทะเบียน" : "ยืนยัน" }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import UploadDocument from "@/components/UploadSingleFile.vue";

export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    dataEdit: {
      default: "",
    },
  },
  data() {
    return {
      cbagree: false,
      saveloading: false,
      input: {
        name: "",
        gender: "",
        age: "",
        dob: "", // YYYY-MM-DD
        phoneNumber: "",
        email: "",
        profileImage: "", // url รูปบัตรที่อัปโหลด
        job: "",
        other_job: "",
      },
      jobOptions: [
        "แพทย์/ เทคนิคการแพทย์",
        "พยาบาล",
        "เภสัชกร",
        "รับราชการ/รัฐวิสาหกิจ",
        "นักกฎหมาย/ผู้ใช้วิชาชีพทางกฎหมาย",
        "นักเรียน/นิสิต/นักศึกษา",
        "วิศวกร",
        "สถาปนิก",
        "มัณฑนากร/จิตรกร/ช่างภาพและช่างศิลป์อื่นๆ",
        "อาจารย์/ครู",
        "ธุรกิจส่วนตัว",
        "อาชีพอิสระ",
        "อื่นๆ (โปรดระบุ)",
      ],
    };
  },
  mounted() {
    if (this.type == "edit" && this.dataEdit) {
      this.input.name = this.dataEdit.name;
      this.input.gender = this.dataEdit.gender;
      this.input.age = this.dataEdit.ages;
      this.input.dob = this.dataEdit.dob;
      this.input.phoneNumber = this.dataEdit.phone_number;
      this.input.email = this.dataEdit.email;
      this.input.job = this.dataEdit.job;

      if (this.dataEdit.job) {
        if ([...this.jobOptions].includes(this.dataEdit.job)) {
          this.input.job = this.dataEdit.job;
        } else {
          this.input.job = "อื่นๆ (โปรดระบุ)";
          this.input.other_job = this.dataEdit.job;
        }
      } else {
        this.input.job = "";
      }

      if (this.input.profileImage == "") {
        this.input.profileImage = this.profileImage;
      } else {
        this.input.profileImage = this.dataEdit.profile_pic;
      }
    } else {
      this.input.profileImage = this.profileImage;
    }
  },
  components: {
    UploadDocument,
    BirthdayPicker,
  },
  computed: {
    moment() {
      return moment;
    },
    profileImage() {
      return this.$store.state.profile.pictureUrl;
    },
  },
  methods: {
    async submitForm() {
      const vm = this;
      try {
        const resultValid = await this.$refs.observer.validate();

        if (!resultValid) {
          return;
        }

        vm.saveloading = true;
        let response = "";

        let data = {
          member_id: vm.$store.state.member.id,
          name: vm.input.name,
          gender: vm.input.gender,
          ages: vm.input.age,
          dob: vm.input.dob,
          phone_number: vm.input.phoneNumber,
          email: vm.input.email,
          profile_pic: vm.input.profileImage, // URL รูป
          job:
            vm.input.job === "อื่นๆ (โปรดระบุ)"
              ? vm.input.other_job
              : vm.input.job,
        };

        if (vm.type === "create") {
          data = {
            ...data,
            userid: vm.$store.state.userid,
            pageid: vm.$store.state.pageid,
            liffuserid: vm.$store.state.profile.userId,
          };

          response = await vm.register(data);
        } else {
          data = {
            ...data,
            member_id: vm.$store.state.member.id,
          };

          response = await vm.editProfile(data);
        }

        vm.saveloading = false;

        if (response && response.data.responsecode == 200) {
          if (vm.type === "create") {
            await this.$store.dispatch("sendMessage", "สมัครสมาชิกสำเร็จ");
            await this.$swal.fire({
              text: "สมัครสมาชิกสำเร็จ",
              confirmButtonColor: "#000",
            });
            this.$liff.closeWindow();
          } else {
            this.$emit("editSuccess");
          }
        } else if (response && response.data.responsecode == 204) {
          await this.$swal.fire({
            text: response.data.reason,
            confirmButtonColor: "#000",
          });
        } else {
          await this.$swal.fire({
            text: response.data.reason,
            confirmButtonColor: "#000",
          });
          this.$liff.closeWindow();
        }
      } catch (error) {
        console.error(error);
        vm.saveloading = false;
      }
    },
    async register(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}lamy/register`;
        const response = await axios.post(url, data, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        vm.saveloading = false;
        return null;
      }
    },
    async editProfile(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}lamy/member`;
        const response = await axios.put(url, data, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
        vm.saveloading = false;
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  padding-top: 0 !important;
  margin-bottom: 12px !important;
}
.v-input--selection-controls {
  margin-top: 0 !important;
}
.theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
